/**
 * Adapters from zoocasa-next's app-local types to @bedrock/analytics's
 * package-owned types, at the boundary where an event is handed to the
 * package's predefined event builders.
 */

import { TenantId as makeTenantId } from '@bedrock/analytics';
import {
  STANDARD_STATUS_UNSPECIFIED,
  STANDARD_STATUS_ACTIVE,
  STANDARD_STATUS_ACTIVE_UNDER_CONTRACT,
  STANDARD_STATUS_CANCELED,
  STANDARD_STATUS_CLOSED,
  STANDARD_STATUS_COMING_SOON,
  STANDARD_STATUS_DELETE,
  STANDARD_STATUS_EXPIRED,
  STANDARD_STATUS_HOLD,
  STANDARD_STATUS_INCOMPLETE,
  STANDARD_STATUS_PENDING,
  STANDARD_STATUS_WITHDRAWN,
  STANDARD_STATUS_UNRECOGNIZED,
} from '@bedrock/analytics';

import type { TenantId, StandardStatusString as BedrockStandardStatusString } from '@bedrock/analytics';
import type { StandardStatusString } from 'types/reso';

/** Wraps a plain tenant id string (e.g. `useTenantId()`'s return value) as the package's branded {@link TenantId}. */
export function toBedrockTenantId(tenantId: string): TenantId {
  return makeTenantId(tenantId);
}

const STANDARD_STATUS_MAP: Record<StandardStatusString, BedrockStandardStatusString> = {
  unspecified: STANDARD_STATUS_UNSPECIFIED,
  active: STANDARD_STATUS_ACTIVE,
  'active under contract': STANDARD_STATUS_ACTIVE_UNDER_CONTRACT,
  canceled: STANDARD_STATUS_CANCELED,
  closed: STANDARD_STATUS_CLOSED,
  'coming soon': STANDARD_STATUS_COMING_SOON,
  delete: STANDARD_STATUS_DELETE,
  expired: STANDARD_STATUS_EXPIRED,
  hold: STANDARD_STATUS_HOLD,
  incomplete: STANDARD_STATUS_INCOMPLETE,
  pending: STANDARD_STATUS_PENDING,
  withdrawn: STANDARD_STATUS_WITHDRAWN,
  unrecognized: STANDARD_STATUS_UNRECOGNIZED,
};

/** Converts zoocasa-next's local RESO status string to the package's RESO-prefixed {@link BedrockStandardStatusString}. */
export function toBedrockStandardStatus(status: StandardStatusString): BedrockStandardStatusString {
  return STANDARD_STATUS_MAP[status];
}
